import { useQuery, keepPreviousData } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchSupportConversations = async ({ page = 1, pageSize = 10 }) => {
  const token = localStorage.getItem("token");
  const params = new URLSearchParams({ page, page_size: pageSize });
  const { data } = await axios.get(`${__API_URL__}/api/support/admin/conversations/?${params}`, {
    headers: { Authorization: `Token ${token}` },
  });
  return data;
};

const useGetSupportConversations = ({ page = 1, pageSize = 10, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["support_conversations", page, pageSize],
    queryFn: () => fetchSupportConversations({ page, pageSize }),
    enabled,
    refetchOnMount: true,
    placeholderData: keepPreviousData,
  });
};

export default useGetSupportConversations;
